import { Box } from "@/components/layout/flexbox";
import { Confirmation } from "@/components/pieces/popup/Confirmation";
import { Attendee } from "@/types/meetings";

interface RemoveMeetingAttendeeConfirmationProps {
  attendee: Attendee;
  onYes: () => void;
  onNo: () => void;
  loading: boolean;
  useDialog: boolean;
}

export function RemoveMeetingAttendeeConfirmation({
  attendee,
  onYes,
  onNo,
  loading,
  useDialog,
}: RemoveMeetingAttendeeConfirmationProps) {
  if (!attendee) return null;
  return (
    <Confirmation
      msg={
        <Box>
          Are you sure you want to remove <b>{attendee?.email}</b>
        </Box>
      }
      onYes={onYes}
      onNo={onNo}
      primaryLabel="Delete"
      cancelLabel="Cancel"
      loading={loading}
      useDialog={useDialog}
    />
  );
}
